export default function Logo({ width = '100%', maxWidth = '100%', style = {}, variant = 'default' }) {
  const isLight = variant === 'light'
  const gaaColor = isLight ? '#FFFFFF' : '#185FA5'
  const matchTrackerColor = isLight ? '#E6F1FB' : '#0d3d6b'
  const taglineColor = isLight ? '#B5D4F4' : '#888888'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 680 320"
      style={{ width, maxWidth, display: 'block', ...style }}>
      <defs>
        <clipPath id="logoClip">
          <path d="M92 52 L228 52 L228 194 Q160 238 92 194 Z"/>
        </clipPath>
      </defs>
      <path d="M92 52 L228 52 L228 192 Q160 236 92 192 Z" fill="#0d3d6b"/>
      <path d="M100 60 L220 60 L220 188 Q160 228 100 188 Z" fill="none" stroke="white" strokeWidth="1" opacity="0.3"/>
      <rect x="115" y="66" width="90" height="118" rx="1" fill="#2d7a3a" clipPath="url(#logoClip)"/>
      <rect x="115" y="66" width="90" height="118" rx="1" fill="none" stroke="white" strokeWidth="1.5"/>
      <line x1="115" y1="125" x2="205" y2="125" stroke="white" strokeWidth="1" strokeDasharray="4,3"/>
      <line x1="115" y1="90" x2="205" y2="90" stroke="white" strokeWidth="0.9"/>
      <line x1="115" y1="160" x2="205" y2="160" stroke="white" strokeWidth="0.9"/>
      <line x1="115" y1="106" x2="205" y2="106" stroke="white" strokeWidth="0.8"/>
      <line x1="115" y1="144" x2="205" y2="144" stroke="white" strokeWidth="0.8"/>
      <rect x="136" y="66" width="48" height="13" fill="none" stroke="white" strokeWidth="1"/>
      <rect x="146" y="66" width="28" height="7" fill="none" stroke="white" strokeWidth="1"/>
      <path d="M140 90 Q160 108 180 90" fill="none" stroke="white" strokeWidth="1.3"/>
      <rect x="136" y="171" width="48" height="13" fill="none" stroke="white" strokeWidth="1"/>
      <rect x="146" y="177" width="28" height="7" fill="none" stroke="white" strokeWidth="1"/>
      <path d="M140 160 Q160 142 180 160" fill="none" stroke="white" strokeWidth="1.3"/>
      <line x1="151" y1="66" x2="151" y2="59" stroke="white" strokeWidth="1.5"/>
      <line x1="169" y1="66" x2="169" y2="59" stroke="white" strokeWidth="1.5"/>
      <line x1="148" y1="62" x2="172" y2="62" stroke="white" strokeWidth="1.2"/>
      <line x1="151" y1="59" x2="151" y2="55" stroke="white" strokeWidth="1"/>
      <line x1="169" y1="59" x2="169" y2="55" stroke="white" strokeWidth="1"/>
      <line x1="151" y1="184" x2="151" y2="191" stroke="white" strokeWidth="1.5"/>
      <line x1="169" y1="184" x2="169" y2="191" stroke="white" strokeWidth="1.5"/>
      <line x1="148" y1="188" x2="172" y2="188" stroke="white" strokeWidth="1.2"/>
      <line x1="151" y1="191" x2="151" y2="195" stroke="white" strokeWidth="1"/>
      <line x1="169" y1="191" x2="169" y2="195" stroke="white" strokeWidth="1"/>
      <line x1="115" y1="115" x2="118" y2="115" stroke="white" strokeWidth="0.8"/>
      <line x1="202" y1="115" x2="205" y2="115" stroke="white" strokeWidth="0.8"/>
      <line x1="115" y1="135" x2="118" y2="135" stroke="white" strokeWidth="0.8"/>
      <line x1="202" y1="135" x2="205" y2="135" stroke="white" strokeWidth="0.8"/>
      <circle cx="207" cy="193" r="23" fill="#0d3d6b"/>
      <circle cx="207" cy="193" r="20" fill="#FAEEDA"/>
      <circle cx="207" cy="193" r="15" fill="none" stroke="#854F0B" strokeWidth="1"/>
      <line x1="207" y1="193" x2="207" y2="181" stroke="#854F0B" strokeWidth="2" strokeLinecap="round"/>
      <line x1="207" y1="193" x2="214" y2="198" stroke="#854F0B" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="207" cy="193" r="2" fill="#854F0B"/>
      <rect x="204" y="172" width="6" height="4" rx="1" fill="#854F0B"/>
      <rect x="201" y="170" width="12" height="3" rx="1.5" fill="#854F0B"/>
      <text x="252" y="124" fontFamily="sans-serif" fontSize="42" fontWeight="700" fill={gaaColor} letterSpacing="-1">GAA</text>
      <text x="252" y="164" fontFamily="sans-serif" fontSize="25" fontWeight="500" fill={matchTrackerColor}>Match Tracker</text>
      <rect x="252" y="174" width="130" height="3" rx="1.5" fill="#2d7a3a"/>
      <text x="253" y="198" fontFamily="sans-serif" fontSize="13" fill={taglineColor} letterSpacing="0.4">Real-time coaching intelligence</text>
    </svg>
  )
}
